import {
    setMapZoom,
    setStoresMarkers
} from './utils';
import debounce from '../../utils/debounce';

const initMap = (center, stores) => {
    const mapContainer = document.querySelector('[data-map-container]');
    const mapOptions = {
        zoom: 8,
        center,
    };
    const map = new google.maps.Map(mapContainer, mapOptions);
    let markerBounds = new google.maps.LatLngBounds();

    new google.maps.Marker({
        position: center,
        map,
        icon: '../../../img/pin.svg'
    });
    setStoresMarkers(stores, map, markerBounds);
    setMapZoom(map, markerBounds);

    window.addEventListener('resize', debounce(() =>
        setMapZoom(map, markerBounds)
    ));
};

export default initMap;
